import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { getFontScale } from 'themes/mixins/getFontScale';

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 3.2rem;
  height: 3.2rem;
  padding: 0;

  border: none;
  border-radius: 0.4rem;
  background: transparent;
  cursor: pointer;

  &:hover {
    background-color: ${pickColor('grayLight')};
  }
`;

const Menu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 10;

  min-width: 16rem;
  margin: 0.4rem 0 0;
  padding: 0.4rem 0;

  background-color: ${pickColor('white')};
  border: 0.1rem solid ${pickColor('grayLight')};
  border-radius: 0.4rem;
  box-shadow: 0 0.2rem 0.8rem rgba(0, 0, 0, 0.12);
`;

const MenuItem = styled.button<{ $danger?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.8rem;

  width: 100%;
  padding: 0.8rem 1.2rem;

  ${getFontScale('s')};
  text-align: left;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
  background: none;
  border: none;
  color: ${({ $danger }) => ($danger ? pickColor('red') : 'inherit')};

  &:hover:not(:disabled) {
    background-color: ${pickColor('gray')};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export { Menu, MenuItem, ToggleButton, Wrapper };
